"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorTokens = void 0;
const __1 = require("..");
const getColorTokens = (props, appearance) => {
    const isButtonPrimary = appearance === __1.ButtonAppearance.Primary;
    const button = {
        disabled: {
            background: isButtonPrimary ? props.theme.colors.button.primary.disabled : 'transparent',
            border: props.theme.colors.border.disabled,
            color: props.theme.colors.content.disabled,
        },
        default: {
            background: isButtonPrimary ? props.theme.colors.button.primary.default : 'transparent',
            border: props.theme.colors.button.primary.default,
            color: isButtonPrimary ? props.theme.colors.content.inverted : props.theme.colors.content.invertedOnSurface,
        },
        hover: {
            background: isButtonPrimary ? props.theme.colors.button.primary.hover : 'transparent',
            border: props.theme.colors.border.hover,
            color: isButtonPrimary ? props.theme.colors.content.inverted : props.theme.colors.content.hover,
        },
        active: {
            background: isButtonPrimary ? props.theme.colors.button.primary.active : 'transparent',
            border: props.theme.colors.border.active,
            color: props.theme.colors.content.active,
        }
    };
    return {
        button,
    };
};
exports.getColorTokens = getColorTokens;
